var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressHold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-hold",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.112,5.165c-0,-1.604 1.299,-2.898 2.903,-2.898c0.404,0 0.788,0.083 1.13,0.228c0.448,-1.027 1.472,-1.745 2.664,-1.745c1.605,0 2.905,1.301 2.905,2.905l0,0.268c0.279,-0.09 0.577,-0.138 0.886,-0.138l0.003,-0.001c1.603,0.003 2.903,1.302 2.904,2.906l0,7.966c-0.005,4.744 -3.85,8.588 -8.594,8.594c-4.794,-0 -6.918,-2.726 -10.053,-9.333c-0.234,-0.419 -0.367,-0.902 -0.367,-1.416c-0,-1.604 1.3,-2.905 2.905,-2.905c1.069,0 2.004,0.578 2.515,1.452l0.198,0.342c-0,0 0.001,-6.284 0.001,-6.225Zm0.134,10.495c0,-0 -2.084,-3.611 -2.085,-3.614c-0.156,-0.259 -0.439,-0.433 -0.763,-0.433c-0.491,0 -0.888,0.398 -0.888,0.888c-0,0.163 0.043,0.316 0.118,0.443l0.001,0.001c0.013,0.024 0.026,0.048 0.038,0.073c1.65,3.481 2.796,5.383 3.968,6.559c1.161,1.163 2.441,1.656 4.275,1.656l0.003,-0c3.631,-0.004 6.573,-2.947 6.577,-6.578l0,-7.965c0,-0.491 -0.397,-0.888 -0.888,-0.888c-0.49,-0 -0.888,0.397 -0.888,0.888l0,4.931c0,0.557 -0.451,1.008 -1.008,1.008c-0.557,0 -1.009,-0.451 -1.009,-1.008l0,-7.966c0,-0.49 -0.397,-0.888 -0.888,-0.888c-0.49,0 -0.888,0.398 -0.888,0.888l0,7.966c0,0.557 -0.451,1.008 -1.008,1.008c-0.557,0 -1.009,-0.451 -1.009,-1.008l0,-6.449c0,-0.49 -0.397,-0.887 -0.888,-0.887c-0.49,-0 -0.888,0.397 -0.888,0.887l0,9.983c0,0.557 -0.451,1.008 -1.008,1.008c-0.371,0 -0.696,-0.2 -0.874,-0.503Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressHold);
export default __webpack_public_path__ + "static/media/iconB-progress-hold.78d035f3ec904718fb94e9a23fd93196.svg";
export { ForwardRef as ReactComponent };